import {
  GesamtabfrageDownloadFile,
  GesamtabfrageDownloadStrategy,
} from './gesamtabfrage-download-strategy';
import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { ModalStore, SOFTLINE_FEATURE_MODAL } from '@softline/ui-core';
import { DateService, Store } from '@softline/core';
import { SOFTLINE_API_DOWNLOAD_ARCHIVE_RECEIPT } from '../../gesamtabfrage.api';
import { formatDate } from '@angular/common';
import { Beleg, Belegart } from '@softapps/wws/gesamtabfrage/api';

@Injectable()
export class ArchivbelegDownloadStrategy implements GesamtabfrageDownloadStrategy {
  type = 'archivbeleg';
  icon = 'fa-regular fa-box-archive';
  label = '#GESAMTABFRAGE.ACTIONS.DOWNLOAD_ARCHIVBELEG';

  locale = inject(LOCALE_ID);
  private store = inject(Store);
  private dateService = inject(DateService);

  async getDownloadFiles(
    belege: Beleg[],
    belegart: Belegart
  ): Promise<GesamtabfrageDownloadFile[]> {
    let combine = false;
    const files: GesamtabfrageDownloadFile[] = [];

    if (belege.length > 1) {
      const result = await this.store.dispatch(
        SOFTLINE_FEATURE_MODAL,
        ModalStore.actions.ask,
        {
          title: '#GESAMTABFRAGE.MODAL.ASK.COMBINE.TITLE',
          question: '#GESAMTABFRAGE.MODAL.ASK.COMBINE.TEXT',
          showCancelAction: true,
          dismiss: true,
        }
      );

      if (result === 'DISMISSED' || result === 'CANCEL') return [];

      combine = result === 'YES';
    }

    if (combine)
      files.push({
        filename: `Belege_${formatDate(this.dateService.now(), 'dd-MM-yyyy_hh-mm', this.locale ?? 'de')}.pdf`,
        location: { path: SOFTLINE_API_DOWNLOAD_ARCHIVE_RECEIPT },
        body: {
          ids: belege.map((o) => +o.id),
          zusammenfassen: true,
          belegart,
          fremdbelegdruck: false,
        },
      });
    else
      for (const beleg of belege)
        files.push({
          filename: `${belegart.id}_${beleg.bezugsnummer ?? beleg.belegnummer}_archiv.pdf`,
          location: { path: SOFTLINE_API_DOWNLOAD_ARCHIVE_RECEIPT },
          body: {
            ids: [beleg.id],
            zusammenfassen: false,
            belegart,
            fremdbelegdruck: false,
          },
        });
    return files;
  }
}
